import { NavLink, Outlet } from "react-router-dom";
import classes from "./MainContent.module.css";
import { useEffect, useRef, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const MainContent = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "+573002515632";
    const message = "Hola! Me gustaría contactarte sobre tu trabajo.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className={classes.main_container}>
      <div className={classes.wrap_container}>
        <div className={classes.left_content}>
          <NavLink to="/aboutme">
            <h1 className={classes.main_header}>Oscar Castro</h1>
          </NavLink>
          <h4 className={classes.sub_header}>Desarrollador Full Stack</h4>
        </div>
        <div className={classes.menu_container}>
          <ul>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? classes.active_link : classes.inactive_link
                }
              >
                Sobre mi
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/skills"
                className={({ isActive }) =>
                  isActive ? classes.active_link : classes.inactive_link
                }
              >
                Habilidades
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/projects"
                className={({ isActive }) =>
                  isActive ? classes.active_link : classes.inactive_link
                }
              >
                Projectos
              </NavLink>
            </li>
            <li className={classes.contact_item}>
              <NavLink
                to="/contactme"
                className={({ isActive }) =>
                  isActive ? classes.active_link : classes.inactive_link
                }
              >
                Contactame
              </NavLink>
            </li>
            <li>
              <FaWhatsapp 
                className={classes.whatsapp_icon} 
                onClick={handleWhatsAppClick}
                />
            </li>
          </ul>
        </div>
      </div>
      <div className={classes.principal}>
        <div
          className={classes.menu_content}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainContent;
